import i18n from '@yandex-int/i18n';
import * as keyset from 'i18n/DraftControlPanel';

import { getIsYangoRequest } from '../../utils';

const t = i18n(keyset);

export const getOnlineDevicesTestingNoteText = () =>
    t(getIsYangoRequest() ? 'meeting-prepare-yango' : 'meeting-prepare-yandex');
